import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import {
    DataGrid,
    GridToolbarContainer
} from '@mui/x-data-grid';
import AddLineItem from './AddLineItem';
import {
    Divider,
    Grid,
    Box,
    Button,
    Card,
    CardHeader,
    CardContent,
    IconButton,
    Tooltip
} from "@mui/material";
import Alert from '@mui/material/Alert';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { updateLineitemDatas } from '../../Settings/ProductLineItems/lineitemSettingsSlice';
import { fetchSkuINfo,resetLineItemSettingsState } from '../../../pages/Settings/ProductLineItems/lineitemSettingsSlice';

const getUniqueId = () => {
    return "SCIT" + Date.now().toString(36) + Math.random().toString(36).substr(2)
}

const LineItems = ({ lineItems, dispatchLineItemCallback, isDuplicateOrder, customLineItems, setCustomLineItems,isReturnOrder,docIdCreate,newOrderFormData,reportName,values,isShipmentCreationFlow,showFieldErrors,activeCountryCode,activeSenderCountryCode  }) => {
    const dispatch = useDispatch();
    const profile = useSelector(state => state.profile);
    const skuInfos = useSelector(state => state.lineitemsettings.skuINfo);
    // Extract the specific strings we want to watch to ensure the Effect fires
    const countryCode = values?.country_code;
    const senderCountryCode = values?.sender_country_code;
    const shippingCountryCode = newOrderFormData?.shipping_address?.country_code;
    const [checkedIds, setCheckedIds] = useState([]);
    const [checkedItems, setCheckedItems] = useState([]);
    // const [pageSize, setPageSize] = useState(5);
    const [addLineItemVisible, setAddLineItemVisible] = useState(false)
    const [removeLineItemId, setRemoveLineItemId] = useState("")
    const [editLineItemId, setEditLineItemId] = useState("")
    const [skuInfo, setSkuInfo] = useState([]);
    const [showAlert, setShowAlert] = useState(false);
    const [paginationModel, setPaginationModel] = React.useState({
        pageSize: 5,
        page: 0,
      });
    const [addLineItemData, setaddLineItemData] = useState({
        "line_item_id": getUniqueId(),
        "product_id": "",
        "sku":"",
        "product_desc": "",
        "product_url": "",
        "product_price": "",
        "hs_tariff_code": "",
        "hs_tariff_code_country": "",
        "edit_line_item_id": "",
        "quantity": "",
        "tracking_number":"",
        "origin_country_code":"",
        "currency":""
    })
    const [lineItemErrors, setLineItemsErrors] = useState({
        "line_item_id": "",
        "product_id": "",
        "sku":"",
        "product_desc": "",
        "product_url": "",
        "product_price": "",
        "hs_tariff_code": "",
        "hs_tariff_code_country": "",
        "quantity": "",
        "origin_country_code":"",
        "currency":""
    });
    let initialColumns = [
        {
            field: 'action',
            headerName: 'Action',
            headerClassName: 'super-app-theme--header',
            width: 100,
            hide: (customLineItems.length == 0),
            renderCell: (params) => {
                if (params.row && params.row.line_item_id && params.row.line_item_id != "") {
                    return <>
                        <span>
                            <Tooltip title="Edit" placement="left-start" disableFocusListener={false}>
                                <IconButton>
                                    <EditIcon style={{  color: 'rgba(0,0,0,.54)', cursor: updateButtonDisable(params.row) ? 'not-allowed' : 'pointer', pointerEvents: updateButtonDisable(params.row) ? 'none' : 'auto' }} onClick={() => setEditLineItemId(params.row.line_item_id)} />
                                </IconButton>
                            </Tooltip>
                        </span>
                        <span>
                            <Tooltip title="Delete" placement="left-start" disableFocusListener={false}>
                                <IconButton>
                                    <DeleteOutlineOutlinedIcon style={{  color: 'rgba(0,0,0,.54)', cursor: updateButtonDisable(params.row) ? 'not-allowed' : 'pointer', pointerEvents: updateButtonDisable(params.row) ? 'none' : 'auto' }}
                                        onClick={() => setRemoveLineItemId(params.row.line_item_id)}
                                    />
                                </IconButton>
                            </Tooltip>
                        </span>
                    </>;
                } else {
                    return <>-</>;
                }
            }

        },
        {
            field: 'quantity',
            headerName: 'Quantity',
            headerClassName: 'super-app-theme--header',
            width: 100,
            renderCell: (params) => {
                if (params.row && params.row.quantity && params.row.quantity != "") {
                    return params.row.quantity;
                }else{
                    return 1;
                }
            }
        },
        {
            field: 'product_price',
            headerName: 'Price',
            headerClassName: 'super-app-theme--header',
            width: 100,
            renderCell: (params) => {
                if (params.row && params.row.product_price && params.row.product_price != "") {
                    return params.row.product_price;
                }else{
                    return "-";
                }
            }
        },
        // {
        //     field: 'product_id',
        //     headerName: 'Product Id',
        //     headerClassName: 'super-app-theme--header',
        //     width: 200,
        //     renderCell: (params) => {
        //         if (params.row && params.row.product_id && params.row.product_id != "") {
        //             return params.row.product_id;
        //         }else if(params.row && params.row.sku && params.row.sku != ""){
        //             return params.row.sku
        //         }else{
        //             return 1;
        //         }
        //     }
        // },
        {
            field: 'sku',
            headerName: 'SKU',
            headerClassName: 'super-app-theme--header',
            width: 200,
            renderCell: (params) => {
                if (params.row && params.row.sku && params.row.sku != "") {
                    return params.row.sku;
                }else{
                    return "-";
                }
            }
        },
        {
            field: 'product_desc',
            headerName: 'Product Description',
            headerClassName: 'super-app-theme--header',
            width: 300,
            renderCell: (params) => {
                if (params.row && params.row.product_desc && params.row.product_desc != "") {
                    return params.row.product_desc;
                }else{
                    return "Product 1";
                }
            }
        }
    ]
    const [columns, setColumns] = useState(initialColumns)

    const updateButtonDisable = (item) => {
        let updateButtonDisable = true;
            if (!item.tracking_number || item.tracking_number === "") {
                updateButtonDisable = false;
            }
        return updateButtonDisable;
    }

    const onCheckedIdsChange = (items) => {
        let productLineItem = [];
        // 1. Highest Priority Check
        const shouldUncheck = !!(profile && profile.profile && profile.profile.uncheck_line_items_default === true);
        const isFromPicklist = reportName === "ORDER_PICKLIST";

        if (items && items.length > 0) {
            // Condition A: If the flag is TRUE, we force everything to be empty (unchecked)
            // UNLESS we are in the Picklist flow which usually requires specific packed items
            if (shouldUncheck && !isFromPicklist) {
                productLineItem = []; // Stay empty
            } 
            // Condition B: Flag is false/missing, proceed with selection logic
            else if (isFromPicklist) {
                items.forEach((item) => {
                    if (item && item.line_item_id && item.is_packed === true) {
                        productLineItem.push(String(item.line_item_id.toString()));
                    }
                });
            } 
            else if (isDuplicateOrder) {
                // Priority 2: If no uncheck flag, select EVERYTHING for duplicates
                items.forEach((item) => {
                    if (item && item.line_item_id) {
                        productLineItem.push(String(item.line_item_id.toString()));
                    }
                });
            }
            else {
                // Priority 3: Standard auto-select (No tracking, not return)
                items.forEach((item) => {
                    if (item && item.line_item_id && !item.tracking_number && !isReturnOrder) {
                        productLineItem.push(String(item.line_item_id.toString()));
                    }
                });
            }
        }
        
        setCheckedIds(productLineItem);
    };




    const onAddLineItemModalClose = () => {
        setRemoveLineItemId("")
        setEditLineItemId("")
        setaddLineItemData({
            "line_item_id": getUniqueId(),
            "product_id": "",
            "sku":"",
            "product_desc": "",
            "product_url": "",
            "product_price": "",
            "hs_tariff_code": "",
            "hs_tariff_code_country": "",
            "edit_line_item_id": "",
            "quantity": "",
            "tracking_number":"",
            "origin_country_code":"",
            "currency":""
        })
        setLineItemsErrors({
            "line_item_id": "",
            "product_id": "",
            "sku":"",
            "product_desc": "",
            "product_url": "",
            "product_price": "",
            "hs_tariff_code": "",
            "hs_tariff_code_country": "",
            "origin_country_code":"",
            "quantity": "",
            "currency":""
        })
        setAddLineItemVisible(false)
    }

    const checkBoxCompute = (tempCheckedIds, tempCheckedItems, item, currentSelectedIds) => {
        const line_item_id = (item.line_item_id) ? item.line_item_id.toString() : ""
        const index = tempCheckedIds.indexOf(line_item_id);
        const method = (currentSelectedIds.indexOf(line_item_id) > -1)
        if (method) {
            if (index === -1) {
                tempCheckedIds.push(line_item_id);
                tempCheckedItems.push(item)
            }
        } else if (!method) {
            if (index > -1) {
                tempCheckedIds.splice(index, 1);
                tempCheckedItems.splice(index, 1);
            }
        }
        return [tempCheckedIds, tempCheckedItems];
    }

    const onSelectionChange = (currentSelectedIds, currentAllItems) => {
        let tempCheckedIds = [...checkedIds]
        let tempCheckedItems = [...checkedItems];
        currentAllItems && currentAllItems.length != 0 && currentAllItems.map((item) => (
            checkBoxCompute(tempCheckedIds, tempCheckedItems, item, currentSelectedIds)
        ))
        setCheckedIds(tempCheckedIds)
        setCheckedItems(tempCheckedItems)
    }

    const formDataHandler = e => {
        const { name, value } = e.target
        setaddLineItemData({
            ...addLineItemData,
            [name]: value
        })
        validateLineItemData();
    }

    const dispatchHandler = e => {
        const { name, value } = e.target
        dispatch(fetchSkuINfo(value));
    }

    const handleBlur = e => {
        const { name, value } = e.target
        if (name === 'product_price' && value !== '') {
            setaddLineItemData({
            ...addLineItemData,
            [name]: parseFloat(value).toFixed(2)
            })
        }
        if (name === 'product_desc' && value !== '') {
            setaddLineItemData({
            ...addLineItemData,
            [name]: value.replace(/[^a-zA-Z0-9]/g, " ")
            })
        }
        setLineItemsErrors({
            ...lineItemErrors,
            [name]: ""
        })
    }

    const handleHsCodeBlur = () => {
        const raw = addLineItemData.hs_tariff_code.replace(/\D/g, ''); // Remove non-digits
        if (raw.length === 10) {
            const formatted = `${raw.slice(0, 4)}.${raw.slice(4, 6)}.${raw.slice(6, 8)}.${raw.slice(8, 10)}`;

            setaddLineItemData(prev => ({
            ...prev,
                hs_tariff_code: formatted
            }));
        }
    };


    const dispatchCountryCode = (id) => {
        setaddLineItemData({
            ...addLineItemData,
            ['origin_country_code']: id
        })
        validateLineItemData();
    }

    const isFloatValue = (value) => {
        value = Number(value);
        if (!isNaN(value) && value.toString().indexOf('.') != -1) {
            return true;
        }
        return false;
    }

    const isIntegerValue = (value) => {
        value = Number(value);
        if (Number.isInteger(value)) {
            return true;
        }
        return false;
    }

    const validateLineItemData = () => {
        let isValid = true
        let lineItemErrorsTemp = {
            "line_item_id": "",
            "product_id": "",
            "sku":"",
            "product_desc": "",
            "product_url": "",
            "product_price": "",
            "hs_tariff_code": "",
            "hs_tariff_code_country": "",
            "origin_country_code":"",
            "quantity": "",
            "currency":""
        };

        // if (addLineItemData.product_id === "" || addLineItemData.product_id === undefined  ||  addLineItemData.product_id === null) {
        //     isValid = false
        //     lineItemErrorsTemp.product_id = "Product id is required";
        // }
        if (addLineItemData.sku == "") {
            isValid = false
            lineItemErrorsTemp.sku = "SKU is required";
        }
        if (addLineItemData.product_desc == "" || addLineItemData.product_desc.length <= 1 || addLineItemData.product_desc.length >= 100) {
            isValid = false
            lineItemErrorsTemp.product_desc = "Product desc is required and should be more than 5 character long";
        }

        // if (addLineItemData.product_url == "" || addLineItemData.product_url.length >= 250) {
        //     isValid = false
        //     lineItemErrorsTemp.product_url = "Product url is required and should be valid";
        // }

        if (addLineItemData.product_price == "" || (!isFloatValue(addLineItemData.product_price) && !isIntegerValue(addLineItemData.product_price))) {
            isValid = false
            lineItemErrorsTemp.product_price = "Product price is required and should be valid";
        }
        if (addLineItemData.product_price<=0) {
            isValid = false
            lineItemErrorsTemp.product_price = "The product price must be a positive number";
        }
        if (addLineItemData.quantity == "" || !isIntegerValue(addLineItemData.quantity)) {
            isValid = false
            lineItemErrorsTemp.quantity = "Product quantity is required and should be a valid";
        }if (addLineItemData.currency == "") {
            isValid = false
            lineItemErrorsTemp.currency = "Currency is required";
        }if (addLineItemData.hs_tariff_code == "" || addLineItemData.hs_tariff_code.replace(/\./g, '').length!==10) {
            isValid = false
            lineItemErrorsTemp.hs_tariff_code = "HsCode is required and Hscode must be 10 digits";
        }if (addLineItemData.origin_country_code == "") {
            isValid = false
            lineItemErrorsTemp.origin_country_code = "Country of origin is required";
        }

        setLineItemsErrors(lineItemErrorsTemp)
        return isValid
    }


    const onAddLineItemClick = () => {
        if (validateLineItemData()) {
            let customLineItemData = [...customLineItems];
            if (addLineItemData.edit_line_item_id == "") {
                customLineItemData.push(addLineItemData)
                setCustomLineItems(customLineItemData)
                setaddLineItemData({
                    "line_item_id": getUniqueId(),
                    "product_id": "",
                    "sku":"",
                    "product_desc": "",
                    "product_url": "",
                    "product_price": "",
                    "hs_tariff_code": "",
                    "hs_tariff_code_country": "",
                    "edit_line_item_id": "",
                    "origin_country_code":"",
                    "quantity": "",
                    "currency":""
                })
            } else if (addLineItemData.edit_line_item_id != "") {
                let editCheckData = _.find(customLineItems, ['line_item_id', addLineItemData.edit_line_item_id])
                // console.log(editCheckData["product_id"])
                // if (editCheckData["product_id"] != addLineItemData.product_id && !_.isUndefined(_.find(customLineItems, ['product_id', addLineItemData.product_id]))) {
                //     console.log("Product already exists")
                //     setLineItemsErrors({
                //         ...lineItemErrors,
                //         [`product_id`]: "Product id already exists"
                //     })
                //     return false
                // }
                let customLineItemData = [...customLineItems];
                let newLineItemData = [];
                customLineItemData.map((item) => {
                    if (item && item.line_item_id && item.line_item_id == addLineItemData.edit_line_item_id) {
                        newLineItemData.push(addLineItemData)
                    } else {
                        newLineItemData.push(item)
                    }
                })
                setCustomLineItems(newLineItemData)
            } else {
                // console.log("Product already exists")
                setLineItemsErrors({
                    ...lineItemErrors,
                    [`product_id`]: "Product already exists"
                })
                return false;
            }
            onAddLineItemModalClose()

        } else {
            console.log("Errors in line items")
        }
    }

    function generate4DigitNumber() {
        const now = new Date();
        const seconds = now.getSeconds(); // 0–59
        const milliseconds = now.getMilliseconds(); // 0–999

        // Combine seconds and milliseconds to seed randomness
        const seed = seconds * 1000 + milliseconds;

        // Use seed to generate a 4-digit number
        const random = Math.floor((Math.random() * seed) % 10000);

        // Pad with leading zeros if needed
        return random.toString().padStart(4, '0');
    }

    const onLineItemsChange = (items) => {
        if (items) {
            let productLineItem = []
            items && items.map((item) => {
                if (item) {
                    // let product_id = 1;
                    // if(item && item.product_id && item.product_id != ""){
                    //     product_id = item.product_id;
                    // }else if(item && item.sku && item.sku != ""){
                    //     product_id = item.sku;
                    // }
                    productLineItem.push({
                        "line_item_id": (item && item.line_item_id && item.line_item_id != "") ? item.line_item_id : getUniqueId(),
                        "product_id": (item && item.product_id && item.product_id != "") ? item.product_id : generate4DigitNumber(),
                        "sku":(item && item.sku && item.sku != "") ? item.sku : "",
                        "product_desc": (item && item.product_desc && item.product_desc != "") ? item.product_desc.replace(/[^a-zA-Z0-9]/g, " ") : "",
                        "product_url": (item && item.product_image && item.product_image != "") ? item.product_image : "",
                        "product_price": (item && item.product_price && item.product_price != "") ? parseFloat(String(item.product_price).replace('$','')).toFixed(2) : "",
                        "hs_tariff_code": (item && item.hs_tariff_code && item.hs_tariff_code != "") ? item.hs_tariff_code : "",
                        "hs_tariff_code_country": (item && item.hs_tariff_code_country && item.hs_tariff_code_country != "") ? item.hs_tariff_code_country : "",
                        "quantity": (item && item.quantity && item.quantity != "") ? item.quantity : "",
                        "tracking_number": (item && item.tracking_number && item.tracking_number != "" && !isDuplicateOrder && !isReturnOrder) ? item.tracking_number : "",
                        "origin_country_code":(item && item.origin_country_code && item.origin_country_code != "") ? item.origin_country_code : "",
                        "currency":(item && item.currency && item.currency != "") ? item.currency : "",
                        "is_packed": item.is_packed ?? false

                    })
                }
            })
            setCustomLineItems(productLineItem)
        }
    }

    useEffect(() => {
        dispatchLineItemCallback(checkedIds)
    }, [checkedIds])

    useEffect(() => {
        if (lineItems && (typeof lineItems !== 'undefined') && lineItems.length != 0) {
            onCheckedIdsChange(lineItems)
            onLineItemsChange(lineItems)
        }
    }, [lineItems])

    useEffect(() => {
        setColumns(initialColumns)
        onCheckedIdsChange(customLineItems)
        let line_items=customLineItems
        let item_reference_id=docIdCreate;
        let finalData = {
            item_reference_id,
            line_items
        };
        if(line_items.length>0){
            dispatch(updateLineitemDatas(finalData))
        }
    }, [customLineItems])

    useEffect(() => {
        if (removeLineItemId != "" && removeLineItemId != "undefined") {
            let customLineItemData = [...customLineItems];
            let newLineItemData = [];
            customLineItemData.map((item) => {
                if (item && item.line_item_id && item.line_item_id != removeLineItemId) {
                    newLineItemData.push(item)
                }
            })
            setCustomLineItems(newLineItemData)
        }
    }, [removeLineItemId])

    useEffect(() => {
        if (editLineItemId != "" && editLineItemId != "undefined" && !_.isUndefined(_.find(customLineItems, ['line_item_id', editLineItemId]))) {
            console.log("Found edit")
            let editData = _.find(customLineItems, ['line_item_id', editLineItemId])
            editData[`edit_line_item_id`] = editLineItemId
            setaddLineItemData(editData)
            setAddLineItemVisible(true)
        }
    }, [editLineItemId])
    useEffect(() => {
        if (skuInfos && skuInfos.data && skuInfos.data.skuinfos && skuInfos.data.skuinfos.length > 0) {
            setSkuInfo(skuInfos.data.skuinfos && skuInfos.data.skuinfos.length>0 ? skuInfos.data.skuinfos:[])
        }
        if (skuInfos && skuInfos.data && skuInfos.data.skuDatas && Object.keys(skuInfos.data.skuDatas).length > 0) {
            const item = skuInfos.data.skuDatas;
            if(editLineItemId!==""){
                setaddLineItemData({
                    line_item_id: editLineItemId,
                    product_id: item.product_id && item.product_id != "" ? item.product_id : generate4DigitNumber(),
                    sku: item.sku,
                    product_desc: item.product_desc.replace(/[^a-zA-Z0-9]/g, " "),
                    product_url:"",
                    product_price: item.product_price,
                    hs_tariff_code: item.hs_tariff_code,
                    hs_tariff_code_country: item.hs_tariff_code_country,
                    edit_line_item_id:editLineItemId,
                    quantity: 1,
                    tracking_number: "",
                    origin_country_code: item.origin_country_code,
                    currency: item.currency
                });
            }else{
                setaddLineItemData({
                    line_item_id: getUniqueId(),
                    product_id: item.product_id && item.product_id != "" ? item.product_id : generate4DigitNumber(),
                    sku: item.sku,
                    product_desc: item.product_desc.replace(/[^a-zA-Z0-9]/g, " "),
                    product_url:"",
                    product_price: item.product_price,
                    hs_tariff_code: item.hs_tariff_code,
                    hs_tariff_code_country: item.hs_tariff_code_country,
                    edit_line_item_id:"",
                    quantity: 1,
                    tracking_number: "",
                    origin_country_code: item.origin_country_code,
                    currency: item.currency
                });
            }
            // Clear errors for fields that now have valid data
            setLineItemsErrors(prev => ({
                ...prev,
                sku: item.sku ? "" : prev.sku,
                product_desc: item.product_desc ? "" : prev.product_desc,
                product_price: item.product_price ? "" : prev.product_price,
                hs_tariff_code: item.hs_tariff_code ? "" : prev.hs_tariff_code,
                origin_country_code: item.origin_country_code ? "" : prev.origin_country_code,
                quantity: item.quantity ? "" : prev.quantity,
                currency: item.currency ? "" : prev.currency
            }));
        } else {
            setaddLineItemData({
                line_item_id: getUniqueId(),
                product_id: "",
                product_desc: "",
                product_url: "",
                product_price: "",
                hs_tariff_code: "",
                hs_tariff_code_country: "",
                edit_line_item_id: "",
                origin_country_code: "",
                quantity: "",
                currency: "",
                sku:addLineItemData.sku
            });
        }
    }, [skuInfos]);


    useEffect(() => {
        if (editLineItemId === "" || editLineItemId === "undefined" ){
            setaddLineItemData({
                "line_item_id": getUniqueId(),
                "product_id": "",
                "sku":"",
                "product_desc": "",
                "product_url": "",
                "product_price": "",
                "hs_tariff_code": "",
                "hs_tariff_code_country": "",
                "edit_line_item_id": "",
                "quantity": "",
                "tracking_number":"",
                "origin_country_code":"",
                "currency":""
            })
        }
        if(!addLineItemVisible){
            dispatch(resetLineItemSettingsState());
        }
    }, [addLineItemVisible])

   
    useEffect(() => {
        // 1. Determine Country String
        const country = isReturnOrder 
            ? (activeSenderCountryCode || "") 
            : (activeCountryCode || newOrderFormData?.shipping_address?.country_code || "");

        const upperCountry = country.toString().toUpperCase().trim();
        const isCanada = upperCountry === "CA" || upperCountry === "CANADA";
        const canBypassItems = isCanada && !isShipmentCreationFlow;

        // 2. Logic: Should we show the error?
        const isMissingSelection = checkedIds.length === 0;
        
        if (showFieldErrors && isMissingSelection && !canBypassItems) {
            setShowAlert(true);
        } else {
            setShowAlert(false);
        }

    // By adding submitCount and direct strings here, it is IMPOSSIBLE for React to ignore the change
    }, [
        showFieldErrors, 
        activeCountryCode, 
        activeSenderCountryCode, 
        checkedIds.length, 
        isReturnOrder, 
        isShipmentCreationFlow
    ]);
    return (
        <>
            <Grid xs={6} md={6} style={{ height: '100%', width: '50%', padding: '10px' }}>
                <Card
                    sx={{ minWidth: 275, boxShadow: 'unset', border: '1px solid rgba(0, 0, 0, 0.12)',maxHeight:'300px',overflowY:'auto' }}
                    className="sc--cardhead--details">
                    <CardHeader
                        title='Line Item'
                        action={
                            <>
                                {((typeof lineItems == 'undefined') ||lineItems.length == 0 || isDuplicateOrder) &&
                                    <Button variant="outlined" aria-label="settings" onClick={() => setAddLineItemVisible(true)}>
                                        Add Line Item
                                    </Button>
                                }
                            </>
                        }
                    />
                    <Divider />
                    <CardContent>
                        <Box
                            component="form"
                            sx={{
                                '& .MuiTextField-root': { m: 1, width: '25ch' },
                            }}
                            noValidate
                            autoComplete="off"
                        >
                            <AddLineItem
                                addLineItemVisible={addLineItemVisible}
                                onAddLineItemModalClose={onAddLineItemModalClose}
                                formDataHandler={formDataHandler}
                                dispatchHandler={dispatchHandler}
                                dispatchCountryCode={dispatchCountryCode}
                                onAddLineItemClick={onAddLineItemClick}
                                addLineItemData={addLineItemData}
                                editLineItemId={editLineItemId}
                                errors={lineItemErrors}
                                handleBlur={handleBlur}
                                handleHsCodeBlur={handleHsCodeBlur}
                                skuOnly={skuInfo}
                            />
                          
                            {showAlert && (
                                <Alert severity="error" sx={{ mt: 2, mb: 2 }}>
                                    Please select at least one item to proceed.
                                </Alert>
                            )}
                            <div className="sc--form--center">
                                <DataGrid
                                    disableRowSelectionOnClick
                                    getRowId={(row) => row.line_item_id ? row.line_item_id.toString() : Math.random()}
                                    rows={customLineItems}
                                    columns={columns}
                                    autoHeight={true}
                                    checkboxSelection
                                    disableColumnFilter={true}
                                    disableColumnMenu={true}
                                    sortingMode="server"
                                    isRowSelectable={(params) => {
                                        if (reportName === "ORDER_PICKLIST") {
                                            return params.row.is_packed === true; // Only packed items can be selected/deselected
                                        }
                                        return !params.row.tracking_number; // Standard logic
                                    }}
                                    onRowSelectionModelChange={(newSelectionModel) => { onSelectionChange(newSelectionModel, (!isDuplicateOrder && !isReturnOrder && lineItems.length != 0) ? lineItems : customLineItems) }}
                                    rowSelectionModel={checkedIds}
                                    // pageSize={pageSize}
                                    // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                    pageSizeOptions={[5, 10, 25]}
                                    paginationModel={paginationModel}
                                    onPaginationModelChange={setPaginationModel}
                                />
                            </div>
                        </Box>
                    </CardContent>
                </Card>
            </Grid>
        </>
    )
};

export default LineItems;